import React, { Component, useState, useEffect } from "react";
import "../../Page/Dashboard/index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiCloseLine,
  RiSpeedFill,
} from "react-icons/ri";
import { BiGridSmall } from "react-icons/bi";
import mixpanel from "mixpanel-browser";
import { BiChevronRight } from "react-icons/bi";

import "./index.css";
import { IoSearch, IoLocationSharp, IoArrowUp } from "react-icons/io5";
import { BsFillPlayFill } from "react-icons/bs";
import { BiPause } from "react-icons/bi";

import { GoPrimitiveDot } from "react-icons/go";

import { TiTick } from "react-icons/ti";
import { firebase } from "../../../firebase/config";
import MobileFooter from "../Layout/mobileFooter";
import {
  US,
  IN,
  PH,
  BR,
  UA,
  PK,
  AR,
  PL,
  MY,
  BD,
  CN,
  MX,
  CO,
  GB,
  ES,
  FR,
  DE,
  IT,
  PT,
} from "country-flag-icons/react/3x2";
import FAQMobile from "../FAQMobile";

import MobileTopMenu from "../Layout/mobileTopMenu";
import { FaMoneyBillAlt, FaYoutube } from "react-icons/fa";

const LandingMobile = () => {
  const [playing, setPlaying] = useState(false);
  const [audio, setAudio] = useState(null);
  const [sample, setSample] = useState(1);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [url, setURL] = useState(
    "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143830/English_sarula.mp4"
  );
  const playAudio = (num) => {
    if (audio) {
      audio.pause();
    }
    if (num === 1) {
      setPlaying(true);
      setAudio(new Audio(require("./Sample.mp3")));
    } else if (num === 2) {
      setPlaying(true);
      setAudio(new Audio(require("./Sample3.mp3")));
    } else {
      setPlaying(true);
      setAudio(new Audio(require("./Sample2.mp3")));
    }
  };

  const pauseAudio = () => {
    if (audio) {
      audio.pause();
    }
    setPlaying(false);
  };

  useEffect(() => {
    if (audio) {
      audio.play();
      audio.addEventListener("ended", () => {
        setPlaying(false);
      });
    }
  }, [audio]);

  useEffect(() => {
    document.body.style.overflow = "unset";
  }, []);

  useEffect(() => {
    if (audio && audio.paused) {
      setPlaying(false);
    }
  }, [audio]);
  return (
    <>
      <div
        style={{
          width: "100vw",
          color: "white",
          overflowX: "hidden",
          backgroundImage:
            "linear-gradient(#080808 1px, transparent 1px), linear-gradient(to right, #080808 1px, #000000 1px)",
        }}
        className="HeroSection"
      >
        <MDBRow
          className="HeroSection"
          style={{
            marginTop: 0,
            paddingBottom: 100,
            backgroundImage:
              "linear-gradient(#080808 1px, transparent 1px), linear-gradient(to right, #080808 1px, #000000 1px) !important",
          }}
        >
          <MobileTopMenu color="dark" />
          <MDBRow
            style={{
              color: "white",
              backgroundImage:
                "linear-gradient(#080808 1px, transparent 1px), linear-gradient(to right, #080808 1px, #000000 1px)",
            }}
            className="HeroSection"
          >
            <MDBCol className="HeroSection" size="12">
              <MDBRow className="HeroSection">
                <MDBCol className="d-flex justify-content-center" size="12">
                  <div
                    style={{
                      height: 40,
                      width: "88%",
                      marginTop: 80,
                      backgroundColor: "#fbfbfb",
                      borderRadius: 5,
                      color: "#5d6b98",
                      textAlign: "center",
                    }}
                  >
                    <p
                      style={{
                        marginTop: 10.5,
                        fontFamily: "PlusJSBold",
                        fontSize: 10.6,
                      }}
                    >
                      NEW - Introducing YouFast, our new model for fast
                      parallelized dubbing
                    </p>
                  </div>
                </MDBCol>
                <MDBCol
                  className="d-flex HeroSection justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 26,
                      textAlign: "center",
                      marginTop: 20,
                      width: "90vw",
                      lineHeight: 1.3,
                      color: "white",
                    }}
                  >
                    Automated dubbing for your
                    <br />
                    videos and podcasts
                    <br />
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      fontSize: 16,
                      marginTop: -80,
                      textAlign: "center",
                      width: "85vw",
                      opacity: 0.7,
                      color: "white",
                    }}
                  >
                    Grow your podcast or youtube channel audience instantly with
                    high quality fast dubbing. Try it free today.
                  </p>
                </MDBCol>
                <MDBCol size="6">
                  <a
                    href="https://app.youdub.me"
                    target="_blank"
                    className="d-flex justify-content-center HeroLink"
                  >
                    <div
                      className="d-flex HeroButton lightButton justify-content-center"
                      style={{
                        borderRadius: 200,
                        paddingTop: 13,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 15,
                        width: 170,
                        height: 49,
                        marginTop: 20,
                        display: "inline-block",
                        marginRight: -60,
                        boxShadow: "3px 3px 0 0 rgb(0 0 0 / 20%)",
                      }}
                    >
                      Try it out
                      <BiChevronRight
                        style={{
                          marginLeft: 5,
                          fontSize: 22,
                          marginBottom: -1,
                        }}
                      />
                    </div>
                  </a>
                </MDBCol>
                <MDBCol size="6">
                  <a
                    className="HeroLink"
                    href="mailto:help@youdub.me"
                    target="_blank"
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      fontFamily: "PlusJSBold",
                      opacity: 1,
                      color: "white",
                    }}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Contact sales{" "}
                    <BiChevronRight
                      style={{
                        marginLeft: 2,
                        fontSize: 22,
                        marginTop: -1.4,
                      }}
                    />
                  </a>
                </MDBCol>
              </MDBRow>
            </MDBCol>
            <MDBCol className="d-flex justify-content-center" size="12">
              <div
                style={{
                  height: 452,
                  width: "90%",
                  backgroundColor: "black",
                  marginTop: -100,
                  borderRadius: 9,
                  border: "1px solid black",
                }}
              >
                <MDBRow>
                  <MDBCol size="12">
                    <MDBRow style={{ width: "100vw" }}>
                      <MDBCol style={{ padding: 0 }} size="4">
                        <div
                          onClick={() => {
                            setURL(
                              "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143830/English_sarula.mp4"
                            );
                            setSelectedLanguage("English");
                          }}
                          style={{
                            height: 90,
                            width: "33vw",
                            backgroundColor: "#505050",
                            borderTopLeftRadius: 9,
                            cursor: "pointer",
                            opacity: selectedLanguage === "English" ? 1 : 0.5,
                          }}
                          className="d-flex justify-content-center"
                        >
                          <MDBRow>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <GB
                                style={{
                                  height: 18,
                                  marginRight: 9,
                                  marginTop: 19,
                                }}
                                title="India"
                              />
                            </MDBCol>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 7,
                                  fontSize: 19,
                                }}
                              >
                                English
                              </p>
                            </MDBCol>
                          </MDBRow>
                        </div>
                      </MDBCol>
                      <MDBCol style={{ padding: 0 }} size="4">
                        <div
                          onClick={() => {
                            setURL(
                              "https://res.cloudinary.com/ditzmaeto/video/upload/v1688143840/Spanish_qomvtd.mp4"
                            );
                            setSelectedLanguage("Spanish");
                          }}
                          style={{
                            height: 90,
                            width: "33vw",

                            backgroundColor: "#505050",
                            cursor: "pointer",
                            opacity: selectedLanguage === "Spanish" ? 1 : 0.5,
                          }}
                          className="d-flex justify-content-center"
                        >
                          <MDBRow>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <ES
                                style={{
                                  height: 18,
                                  marginRight: 9,
                                  marginTop: 19,
                                }}
                                title="India"
                              />
                            </MDBCol>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 7,
                                  fontSize: 19,
                                }}
                              >
                                Spanish
                              </p>
                            </MDBCol>
                          </MDBRow>
                        </div>
                      </MDBCol>
                      <MDBCol style={{ padding: 0 }} size="4">
                        <div
                          onClick={() => {
                            setURL(
                              "https://res.cloudinary.com/ditzmaeto/video/upload/v1688147216/Hindi_icqg3f.mp4"
                            );
                            setSelectedLanguage("Hindi");
                          }}
                          style={{
                            height: 90,
                            width: "33vw",
                            backgroundColor: "#505050",
                            cursor: "pointer",
                            opacity: selectedLanguage === "Hindi" ? 1 : 0.5,
                          }}
                          className="d-flex justify-content-center"
                        >
                          <MDBRow>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <IN
                                style={{
                                  height: 18,
                                  marginRight: 9,
                                  marginTop: 19,
                                }}
                                title="India"
                              />
                            </MDBCol>
                            <MDBCol
                              className="d-flex justify-content-center"
                              size="12"
                            >
                              <p
                                style={{
                                  fontFamily: "PlusJSBold",
                                  marginTop: 7,
                                  fontSize: 19,
                                }}
                              >
                                Hindi
                              </p>
                            </MDBCol>
                          </MDBRow>
                        </div>
                      </MDBCol>
                      <MDBCol style={{ padding: 0 }} size="6">
                        <div
                          onClick={() => {
                            setURL(
                              "https://res.cloudinary.com/ditzmaeto/video/upload/v1688152404/French_ftgjpk.mp4"
                            );
                            setSelectedLanguage("French");
                          }}
                          style={{
                            height: 90,
                            width: "50vw",
                            backgroundColor: "#505050",
                            opacity: selectedLanguage === "French" ? 1 : 0.5,
                            cursor: "pointer",
                          }}
                          className="d-flex justify-content-center"
                        >
                          <p
                            style={{
                              fontFamily: "PlusJSBold",
                              marginTop: 29,
                              fontSize: 19,
                            }}
                          >
                            <FR
                              style={{
                                height: 18,
                                marginRight: 9,
                                marginTop: -6,
                              }}
                              title="India"
                            />
                            French
                          </p>
                        </div>
                      </MDBCol>
                      <MDBCol style={{ padding: 0 }} size="6">
                        <div
                          onClick={() => {
                            setURL(
                              "https://res.cloudinary.com/ditzmaeto/video/upload/v1688152397/German_du6swe.mp4"
                            );
                            setSelectedLanguage("German");
                          }}
                          style={{
                            height: 90,
                            width: "50vw",
                            borderBottomLeftRadius: 0,
                            backgroundColor: "#505050",
                            opacity: 0.5,
                            cursor: "pointer",
                            opacity: selectedLanguage === "German" ? 1 : 0.5,
                          }}
                          className="d-flex justify-content-center"
                        >
                          <p
                            style={{
                              fontFamily: "PlusJSBold",
                              marginTop: 29,
                              fontSize: 19,
                            }}
                          >
                            <DE
                              style={{
                                height: 18,
                                marginRight: 9,
                                marginTop: -6,
                              }}
                              title="India"
                            />
                            German
                          </p>
                        </div>
                      </MDBCol>
                    </MDBRow>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <video
                      src={url}
                      controls
                      style={{
                        width: "100vw",

                        height: 350,
                        objectFit: "cover",
                      }}
                    />
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBRow>

        <MDBRow
          style={{
            marginTop: 0,
            overflowY: "hidden",
            paddingTop: 60,
            paddingBottom: 50,
            color: "white",
            width: "105vw",
            overflowX: "hidden",
          }}
          className="HeroSection"
        >
          <MDBCol className="d-flex justify-content-center" size="12">
            <p
              style={{
                fontFamily: "PlusJSBold",
                fontSize: 23,
                fontWeight: "600",
                textAlign: "center",
                lineHeight: 0.6,
              }}
            >
              Why should I use{" "}
              <p style={{ fontFamily: "Grifter", display: "inline-block" }}>
                YouDub
              </p>{" "}
            </p>
          </MDBCol>

          <MDBCol className="d-flex justify-content-center" size="12">
            <MDBRow style={{ width: "95vw", marginTop: 50 }}>
              <MDBCol
                style={{ paddingLeft: 20 }}
                className="d-flex justify-content-center"
                size="6"
              >
                <MDBRow>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <FaMoneyBillAlt style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        marginTop: 12,
                        fontSize: 15,
                      }}
                    >
                      Save money
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: 0,
                        opacity: 0.7,
                        fontSize: 13,
                        width: 180,
                      }}
                    >
                      We offer the best prices per min of dubbing. We are
                      typically 50% cheaper than competition.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol className="d-flex justify-content-center" size="6">
                <MDBRow>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <RiSpeedFill style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        fontSize: 15,
                        marginTop: 12,
                      }}
                    >
                      Fastest generator
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: 0,
                        opacity: 0.7,
                        fontSize: 13,
                        width: 180,
                      }}
                    >
                      Our dubbing engine can run unlimited number of tasks in
                      parallel. We are 40% faster than competition.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol className="d-flex justify-content-center" size="12">
                <MDBRow style={{ marginTop: 20 }}>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <FaYoutube style={{ color: "white", fontSize: 30 }} />
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSSemiBold",
                        marginTop: 14,
                      }}
                    >
                      Built for scale
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    {" "}
                    <p
                      style={{
                        textAlign: "center",
                        fontFamily: "PlusJSMedium",
                        marginTop: -9,
                        opacity: 0.7,
                        fontSize: 14,
                        width: "70%",
                      }}
                    >
                      We've built YouDub with scale in mind, designed for
                      enterprise customers and large channels from the start.
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBCol>

          <MDBCol
            style={{
              paddingBottom: 50,
              marginTop: 70,
              color: "white",
            }}
            className="HeroSection d-flex justify-content-center"
            size="12"
          >
            <MDBRow style={{ marginTop: 40 }}>
              <MDBCol className="d-flex justify-content-center" size="12">
                <p
                  style={{
                    fontFamily: "PlusJSBold",
                    fontSize: 23,
                    fontWeight: "600",
                    textAlign: "center",
                    lineHeight: 1.3,
                  }}
                >
                  Works with many languages
                </p>
              </MDBCol>
              <MDBCol
                className="d-flex justify-content-center"
                style={{ marginTop: -5 }}
                size="12"
              >
                <p
                  style={{
                    fontFamily: "PlusJSMedium",
                    fontSize: 15,
                    textAlign: "center",
                    marginTop: 0,
                    width: "80%",
                    opacity: 0.7,
                    lineHeight: 1.6,
                  }}
                >
                  YouDub is able to dub into 8 different languages covering 96%
                  of the world's population.
                </p>
              </MDBCol>
              <MDBCol
                size="12"
                style={{
                  width: "90%",
                  paddingBottom: 10,
                  marginTop: 10,
                  color: "black",
                }}
                className="d-flex justify-content-center"
              >
                <MDBRow
                  style={{
                    height: "65%",
                  }}
                >
                  <MDBCol className="d-flex justify-content-center" size="6">
                    <div
                      style={{
                        height: 50,
                        width: "100%",
                        backgroundColor: "white",
                        marginLeft: 10,
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <IN
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="India"
                        />
                        India
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="6">
                    <div
                      style={{
                        height: 50,
                        width: "100%",

                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <ES
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Phillipines"
                        />
                        Spanish
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",

                        marginLeft: 10,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <DE
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Brazil"
                        />
                        German
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <IT
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Ukraine"
                        />
                        Italian
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",

                        marginLeft: 10,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <GB
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Pakistan"
                        />
                        English
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <FR
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Argentina"
                        />
                        French
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",

                        marginLeft: 10,
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <PL
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Poland"
                        />
                        Poland
                      </p>
                    </div>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="6"
                  >
                    <div
                      style={{
                        height: 50,
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    >
                      {" "}
                      <p
                        style={{
                          fontFamily: "PlusJSSemiBold",
                          textAlign: "center",
                          marginTop: 14,
                          opacity: 0.7,
                          fontSize: 14,
                        }}
                      >
                        <PT
                          style={{
                            height: 16,
                            marginRight: 9,
                            marginTop: -2,
                          }}
                          title="Malaysia"
                        />
                        Portuguese
                      </p>
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBCol>

          <FAQMobile />

          <MDBCol className="d-flex justify-content-center" size="12">
            <hr
              style={{
                width: "84%",
                color: "black",
                height: 1,
                marginTop: 70,
              }}
            />
          </MDBCol>
          <MDBCol size="12">
            <p
              style={{
                fontFamily: "PlusJSExtraBold",
                marginTop: 60,
                fontSize: 30,
                lineHeight: 1.3,
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Learn more
              <br />
              about YouDub<sup>TM</sup>
            </p>
            <a
              href=""
              target="_blank"
              className="d-flex justify-content-center"
              onClick={() => window.scrollTo(0, 0)}
            >
              <div
                className="d-flex justify-content-center"
                style={{
                  backgroundColor: "#FF0000",
                  borderRadius: 5,
                  paddingTop: 10,
                  color: "white",
                  fontFamily: "PlusJSBold",
                  fontSize: 17,
                  width: 170,
                  height: 49,
                  marginTop: 10,
                  display: "inline-block",
                }}
              >
                Book a Demo
              </div>
            </a>
          </MDBCol>
          <MDBCol style={{ paddingLeft: "7%" }} size="12">
            <img
              src={require("./fingers.png")}
              style={{ height: 240, width: "auto", marginTop: 50 }}
            />
          </MDBCol>
        </MDBRow>
      </div>
      <div
        style={{ width: "100vw", backgroundColor: "black" }}
        className="HeroSection"
      >
        <MobileFooter />
      </div>
    </>
  );
};

export default withRouter(LandingMobile);
